import React, { FC } from 'react';
import { Spin } from 'antd';
import moment from 'moment-timezone';
import { WEEKDAY_LABELS } from '../../data/constants';
import type { MonthDirection } from '../../utils/booking-analytics';
import MonthNav from './month-nav';

interface MobileDateStripProps {
  calendarMonth: number
  calendarYear: number
  /** Bookable dates (YYYY-MM-DD) in the shown month. */
  dates: string[]
  selectedDate: string
  loading: boolean
  onChangeMonth: (direction: MonthDirection) => void
  onSelectDate: (dateKey: string) => void
}

const MobileDateStrip: FC<MobileDateStripProps> = ({
  calendarMonth,
  calendarYear,
  dates,
  selectedDate,
  loading,
  onChangeMonth,
  onSelectDate,
}) => (
  <Spin spinning={loading}>
    <MonthNav
      calendarMonth={calendarMonth}
      calendarYear={calendarYear}
      onChangeMonth={onChangeMonth}
      className="flex items-center justify-between mb-3"
      buttonClassName="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-200 text-slate-600 font-bold"
    />
    <div className="adhd-date-strip">
      {dates.map((dateKey) => {
        const dayNum = parseInt(dateKey.split('-')[2], 10);
        const weekday = WEEKDAY_LABELS[moment(dateKey).day()];
        const isSelected = selectedDate === dateKey;
        return (
          <button
            key={dateKey}
            type="button"
            className={`adhd-date-chip ${isSelected ? 'on' : ''}`}
            onClick={() => onSelectDate(dateKey)}
          >
            <small>{weekday}</small>
            <b>{dayNum}</b>
            <i />
          </button>
        );
      })}
    </div>
  </Spin>
);

export default MobileDateStrip;
